import { isNullOrUndefined, addClass, createElement, append, EventHandler } from '@syncfusion/ej2-base';
import { ListBase } from '@syncfusion/ej2-lists';
import * as util from '../base/util';
import * as cls from '../base/css-constant';
import * as event from '../base/constant';
/**
 * AgendaBase for event rendering
 */
var AgendaBase = /** @class */ (function () {
    /**
     * Constructor for AgendaBase
     */
    function AgendaBase(parent) {
        this.parent = parent;
        this.l10n = this.parent.localeObj;
    }
    AgendaBase.prototype.createAgendaContentElement = function (type, listData, aTd) {
        var listElement;
        if (type === 'noEvents') {
            var noEvents = [{ 'subject': this.l10n.getConstant('noEvents') }];
            listElement = ListBase.createList(noEvents, {
                moduleName: 'agenda',
                listClass: this.parent.activeView.viewClass,
                itemClass: this.parent.activeView.viewClass,
                template: '<div class=' + cls.AGENDA_NO_EVENT_CLASS + '>${subject}</div>'
            });
        }
        else {
            listElement = ListBase.createList(listData, {
                moduleName: 'agenda',
                listClass: this.parent.activeView.viewClass,
                itemClass: this.parent.activeView.viewClass
            });
            for (var li = 0, length_1 = listData.length; li < length_1; li++) {
                var appWrapper = createElement('div', {
                    id: 'Appointment_' + listData[li][this.parent.eventFields.id],
                    className: cls.APPOINTMENT_CLASS, attrs: {
                        'data-guid': listData[li].Guid,
                        'role': 'button',
                        'tabindex': '0',
                        'aria-readonly': 'false',
                        'aria-selected': 'false',
                        'aria-grabbed': 'true',
                        'aria-label': isNullOrUndefined(listData[li][this.parent.eventFields.subject]) ?
                            this.parent.eventSettings.fields.subject.default : listData[li][this.parent.eventFields.subject]
                    }
                });
                var templateEle = void 0;
                if (!isNullOrUndefined(this.parent.activeViewOptions.eventTemplate)) {
                    templateEle = this.parent.getAppointmentTemplate()(listData[li]);
                }
                else {
                    templateEle = this.createAppointment(listData[li]);
                }
                append([].slice.call(templateEle), appWrapper);
                listElement.children[li].innerHTML = appWrapper.outerHTML;
                var args = { data: listData[li], element: listElement.children[li] };
                this.parent.trigger(event.eventRendered, args);
            }
        }
        aTd.appendChild(listElement);
        addClass([aTd], cls.AGENDA_DAY_BORDER_CLASS);
        return aTd;
    };
    AgendaBase.prototype.createAppointment = function (event) {
        var fieldMapping = this.parent.eventFields;
        var recordSubject = isNullOrUndefined(event[fieldMapping.subject]) ?
            this.parent.eventSettings.fields.subject.default : event[fieldMapping.subject];
        var appSubjectWrap = createElement('div', { className: cls.APPOINTMENT_SUBJECT_WRAP });
        if (!isNullOrUndefined(event[fieldMapping.location]) && event[fieldMapping.location] !== '') {
            recordSubject += ',';
        }
        appSubjectWrap.appendChild(createElement('div', {
            className: cls.APPOINTMENT_SUBJECT,
            innerHTML: recordSubject
        }));
        if (!isNullOrUndefined(event[fieldMapping.location])) {
            appSubjectWrap.appendChild(createElement('div', {
                className: cls.APPOINTMENT_LOCATION,
                innerHTML: event[fieldMapping.location]
            }));
        }
        if (!isNullOrUndefined(event[fieldMapping.recurrenceRule])) {
            var iconClass = (event[fieldMapping.id] === event[fieldMapping.recurrenceID]) ?
                cls.EVENT_RECURRENCE_ICON_CLASS : cls.EVENT_RECURRENCE_EDIT_ICON_CLASS;
            appSubjectWrap.appendChild(createElement('div', { className: cls.ICON + ' ' + iconClass }));
        }
        var strDate = event[fieldMapping.startTime];
        var endDate = event[fieldMapping.endTime];
        var isAllDay = event[fieldMapping.isAllDay];
        var allDayStr = this.l10n.getConstant('allDay');
        var timeStr = this.parent.globalize.formatDate(strDate, { skeleton: 'hm' }) + ' - ' +
            this.parent.globalize.formatDate(endDate, { skeleton: 'hm' });
        if (!isNullOrUndefined(event.data)) {
            var eventString = (endDate.getTime() - strDate.getTime()) / util.MS_PER_DAY >= 1 ? allDayStr : timeStr;
            allDayStr = eventString + ' (' + this.l10n.getConstant('day') + ' ' + event.data.index + '/' +
                event.data.count + ')';
        }
        var appDateTime = createElement('div', {
            className: cls.AGENDA_DATETIME_CLASS,
            innerHTML: (!isNullOrUndefined(event.data) || isAllDay) ? allDayStr : timeStr
        });
        return [appSubjectWrap, appDateTime];
    };
    AgendaBase.prototype.processAgendaEvents = function (events) {
        var eventsProcessed = [];
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            var splited = this.parent.eventBase.splitEventByDay(event_1);
            eventsProcessed = eventsProcessed.concat(splited.length > 1 ? splited : event_1);
        }
        return eventsProcessed;
    };
    AgendaBase.prototype.wireEventActions = function () {
        var eventElement = [].slice.call(this.parent.element.querySelectorAll('.' + cls.APPOINTMENT_CLASS));
        for (var _i = 0, eventElement_1 = eventElement; _i < eventElement_1.length; _i++) {
            var element = eventElement_1[_i];
            this.parent.eventBase.wireAppointmentEvents(element);
        }
        var dateHeaderElement = [].slice.call(this.parent.element.querySelectorAll('.e-m-date'));
        for (var _a = 0, dateHeaderElement_1 = dateHeaderElement; _a < dateHeaderElement_1.length; _a++) {
            var element = dateHeaderElement_1[_a];
            EventHandler.add(element, 'click', this.parent.agendaModule.dayNavigationClick, this);
        }
    };
    return AgendaBase;
}());
export { AgendaBase };
